import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=288859c6&scoped=true&"
import script from "./upload-image.ts?vue&type=script&lang=ts&"
export * from "./upload-image.ts?vue&type=script&lang=ts&"
import style0 from "./upload-image.scss?vue&type=style&index=0&id=288859c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288859c6",
  null
  
)

export default component.exports